import { useEffect } from "react";
import { useSiteContent } from "./siteContent";

function upsertMeta(attrName, attrValue, content) {
  let tag = document.querySelector(`meta[${attrName}="${attrValue}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attrName, attrValue);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

/**
 * Sets document.title, meta description, and Open Graph / Twitter tags
 * based on the SEO settings managed in the admin editor.
 */
export function useSeo(pageKey, defaultTitleFallback) {
  const { content } = useSiteContent();
  useEffect(() => {
    const siteName = (content?.site?.siteName || "The Cozy Cove").trim();
    const pageSeo = (content?.site?.seo && content.site.seo[pageKey]) || {};
    const t = (pageSeo.title || defaultTitleFallback || pageKey).trim();
    const fullTitle = `${t} | ${siteName}`;
    document.title = fullTitle;

    const desc = (pageSeo.description || "").trim() ||
      "Cozy, unforgettable teepee sleepover experiences for birthdays, celebrations, and special nights.";
    const ogImage = content?.site?.ogImageUrl ||
      "https://customer-assets.emergentagent.com/job_teepee-magic-nights/artifacts/g1w0mtsx_the%20cozy%20cove%20logo.jpeg";

    upsertMeta("name", "description", desc);
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:image", ogImage);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:url", window.location.href);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", desc);
    upsertMeta("name", "twitter:image", ogImage);
  }, [content, pageKey, defaultTitleFallback]);
}
